module.exports = __webpack_public_path__ + "static/img/logo.8277aefe.png";